import { Injectable } from '@angular/core';
import { DialogService } from '@libs/index';
import { ServerCallerService } from '@libs/index';
import { NavigationService } from '../navigation/navigation.service';
import { StateService } from '../state/state.service';
import { IframeService } from '../iframe/iframe.service';
import { AbstractAuthenticationService } from '@libs/index';
import { StorageService } from '../storage/storage.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService extends AbstractAuthenticationService {
  constructor(
    protected serverCaller: ServerCallerService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
    private storageService: StorageService,
    private stateService: StateService,
    private iframeService: IframeService
  ) {
    super(serverCaller);
  }

  public async login(username: string, password: string) {
    const token = await super.loginAndReturnToken(username, password);
    this.stateService.setToken(token);

    if (this.iframeService.isInIframe()) {
      this.iframeService.emitSaveTokenEvent(token);
    }
  }

  public override async logout(): Promise<boolean> {
    if (this.navigationService.isPrivateRoute(window.location.pathname)) {
      return this.logoutAndSaveRedirectLink(window.location.href);
    } else {
      return this.logoutAndSaveRedirectLink(null);
    }
  }

  public async logoutAndSaveRedirectLink(
    redirectLink: string
  ): Promise<boolean> {
    // clear state
    this.stateService.clearWhenLogout();

    // emit RemoveTokenEvent if in iframe mode
    if (this.iframeService.isInIframe()) {
      this.iframeService.emitRemoveTokenEvent();
    }

    // close all currently opening dialogs
    this.dialogService.closeAll();
    this.storageService.removeCachedCalendarData();

    if (redirectLink?.length) {
      await this.navigationService.navigateToLogin(redirectLink);
    }

    return true;
  }
}
